import { createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import * as fromProfile from '../reducers/profile.reducer';
import * as fromUser from '../reducers/user.reducer';
import { ProfileHelper } from '../../../shared/helper/profile.helper';
import { IProfile } from '@scf-monorepo/interfaces';

const selectProfile = (state: fromApp.AppState) => state.profile;
const selectUser = (state: fromApp.AppState) => state.user;

export const selectProfileSelectedProfile = createSelector(
    selectProfile,
    selectUser,
    (state: fromProfile.State, user: fromUser.State) => {
        const initiallySelectedProfile = ProfileHelper.getActiveProfile(state.profiles, user?.currentUser?.gid);
        const currentlySelectedProfile = state.profiles.find((profile: IProfile) => profile.id === state.selectedId);
        return currentlySelectedProfile || initiallySelectedProfile || null;
    }
);

export const selectProfileActiveProfile = createSelector(
    selectProfile,
    selectUser,
    (state: fromProfile.State, user: fromUser.State) =>
        ProfileHelper.getActiveProfile(state.profiles, user?.currentUser?.gid)
);

export const selectProfileProfiles = createSelector(selectProfile, (state: fromProfile.State) => state.profiles);

export const selectProfileUserProfile = createSelector(
    selectProfile,
    selectUser,
    (profileState: fromProfile.State, userState: fromUser.State) => {
        if (!userState.currentUser || !profileState.profiles) {
            return null;
        }

        return ProfileHelper.getUserProfile(profileState.profiles, userState.currentUser.gid);
    }
);

export const selectProfileById = createSelector(
    selectProfile,
    (state: fromProfile.State, props: { id: string }) =>
        !!props.id && state.profiles.find((profile) => profile.id === props.id)
);

export const selectProfileThemeIsSet = createSelector(selectProfile, (state: fromProfile.State) => state.themeIsSet);
